import {
  CREATE_FORTNIGHTLY,
  DELETE_FORTNIGHTLY,
  GET_FORTNIGHTLY_DELETE,
  GET_FORTNIGHTLY_WEEKS,
  GET_FORTNIGHTLY_YEARS,
} from '../types';

const initialState = {
  fortnightlys: [],
  fortnightlysWeeks: [],
  fortnightlyDelete: null,
};

export default function Fortnightlys(state = initialState, action) {
  switch (action.type) {
    case CREATE_FORTNIGHTLY:
      return {
        ...state,
        fortnightlys: [action.payload],
      };
    case GET_FORTNIGHTLY_YEARS:
      return {
        ...state,
        fortnightlys: action.payload,
      };
    case GET_FORTNIGHTLY_WEEKS:
      return {
        ...state,
        fortnightlysWeeks: action.payload,
      };
    case GET_FORTNIGHTLY_DELETE:
      return {
        ...state,
        fortnightlyDelete: action.payload,
      };
    case DELETE_FORTNIGHTLY:
      return {
        ...state,
        fortnightlys: state.fortnightlys.filter(
          (fortnightly) => fortnightly.id !== state.fortnightlyDelete
        ),
      };

    default:
      return state;
  }
}
